import Cookies from 'js-cookie'

interface Options {
  name: string
  value: any | null
}

export function setCookie({name, value}: Options) {
  Cookies.set(name, value)
}

export function removeCookie(name) {
  Cookies.remove(name)
}
